import { Box, Checkbox, CircularProgress } from '@material-ui/core'
import React from 'react'

export function CheckboxComponent(props: { onChange: Function; disabled: boolean; fetching: boolean; checked: boolean }) {
  const { fetching, disabled, checked, onChange } = props
  if (fetching) {
    return (
      <Box>
        <CircularProgress size={25} />
      </Box>
    )
  } else {
    return (
      <Checkbox
        disabled={disabled}
        checked={checked}
        onChange={(e: any) => {
          onChange(e.target.checked)
        }}
      />
    )
  }
}
